export default [
  {
    text: 'Action',
    value: 'action',
  },
  {
    text: 'Date de création',
    value: 'creationDate',
    filterable: false,
  },
  {
    text: 'Date de mise à jour',
    value: 'updateDate',
    filterable: false,
  },
  {
    text: 'Code TVA',
    value: 'intracommunityVAT',
  },
  {
    text: 'Code Hyper',
    value: 'hyperCode',
  },
  {
    text: 'Code Super',
    value: 'proxiCode',
  },
  {
    text: 'Libellé fournisseur',
    value: 'supplierLabel',
  },
  {
    text: 'Mode de livraison',
    value: 'deliveryType',
  },
  {
    text: 'Nomenclature',
    value: 'proxiHierarchyList',
  },
  {
    text: 'Commentaire',
    value: 'comment',
  },
]
